module.exports = __webpack_public_path__ + "static/apple-icon-180x180-2e113283f12bcf2c927857cbb1905f5a.png";